import { defineNuxtPlugin } from "#app";

export default defineNuxtPlugin(() => {
  if (process.client) {
    const applyFadeObserver = () => {
      const fadeElements = document.querySelectorAll(".fade-in");

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");
              observer.unobserve(entry.target); // (optionnel : évite de re-observer)
            }
          });
        },
        { threshold: 0.2 }
      );

      fadeElements.forEach((el) => observer.observe(el));
    };

    // Quand le DOM est prêt :
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", applyFadeObserver);
    } else {
      applyFadeObserver();
    }
  }
});
